import { Type } from '@sinclair/typebox';
export const BORGEE_AGENT_REMOTE_PROTOCOL_VERSION = '1.6.0';
export const PROTOCOL_VERSION = BORGEE_AGENT_REMOTE_PROTOCOL_VERSION;
export const ProtocolVersionSchema = Type.Literal(BORGEE_AGENT_REMOTE_PROTOCOL_VERSION);
//# sourceMappingURL=version.js.map